// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"28da3488","692":"28da3488"}[chunkId] + ".chunk.css";
};